<template>
<div
    id="app-banner"
    :class="[
        appStore.mainBanner.type === 'success' ? 'tw:!border-t-5 tw:!border-t-[#68B79E]' : null,
        appStore.mainBanner.type === 'error' ? 'tw:!border-t-5 tw:!border-t-[#BE3A3A]' : null,
        appStore.mainBanner.type === 'warning' ? 'tw:!border-t-5 tw:!border-t-[#C08A0C]' : null,
        appStore.mainBanner.type === 'info' ? 'tw:!border-t-5 tw:!border-t-[#94B9ED]' : null,
        lg ? 'app-banner-lg tw:fixed tw:h-[85px] tw:z-[10000]' : null,
        sm && !isPortal ? 'app-banner-sm tw:relative tw:top-[90px] tw:w-full tw:mb-3' : null,
        sm && isPortal ? 'app-banner-sm tw:relative tw:mt-[76px] tw:w-full tw:mb-3' : null
    ]"
    class="tw:flex tw:flex-col tw:justify-center tw:items-start tw:text-black border-b tw:bg-white tw:p-4 tw:lg:top-0 tw:lg:right-0 tw:lg:left-0 box-border">
        <div class="tw:lg:flex tw:w-full tw:lg:items-center">
            <div class="tw:flex-1">
                <div
                    :class="[
                        appStore.mainBanner.type === 'success' ? 'tw:text-[#68B79E]' : null,
                        appStore.mainBanner.type === 'error' ? 'tw:text-[#BE3A3A]' : null,
                        appStore.mainBanner.type === 'warning' ? 'tw:text-[#C08A0C]' : null,
                        appStore.mainBanner.type === 'info' ? 'tw:text-[#94B9ED]' : null,
                    ]"
                    class="tw:flex tw:items-start tw:gap-2">
                    <span class="tw:w-[20px] tw:inline-block tw:shrink-0">
                        <font-awesome-icon class="tw:text-[18px] tw:mt-0.5" :icon="appStore.mainBanner.type === 'success' ? faCircleCheck : faTriangleExclamation"></font-awesome-icon>
                    </span>
                    <h5 class="tw:!m-0 tw:font-bold">{{ appStore.mainBanner.title }}</h5>
                </div>
                <div class="tw:flex tw:gap-2 tw:mt-2">
                    <div class="tw:w-[20px]"></div>
                    <p class="tw:text-sm tw:font-medium tw:leading-none" v-html="sanitizeHtml(appStore.mainBanner.msg)"></p>
                </div>
            </div>
            <div
                v-if="appStore.mainBanner.href"
                class="tw:lg:flex-0 tw:w-full tw:py-1 tw:lg:py-4 tw:text-left tw:ml-5 tw:lg:ml-0 tw:lg:text-left tw:whitespace-nowrap">
                <NuxtLink :to="appStore.mainBanner.href">
                    {{ linkStr }}
                </NuxtLink>
            </div>
        </div>
</div>
</template>
<script setup>
import { useAppStore } from '@/store/app'
import { faTriangleExclamation, faCircleCheck } from '@fortawesome/pro-solid-svg-icons'
const appStore = useAppStore()
const { sanitizeHtml } = useSanitize()
defineProps({
    lg: {
        type: Boolean,
        default: false
    },
    sm: {
        type: Boolean,
        default: false
    },
    isPortal: {
        type: Boolean,
        default: false
    }
})

const linkStr = computed(() => appStore.mainBanner.linkText ? appStore.mainBanner.linkText : 'Go')

</script>
<style lang="scss" scoped>
.app-banner-lg {
    @include media-breakpoint-down(lg) {
        display: none;
    }
}
.app-banner-sm {
    @include media-breakpoint-up(lg) {
        display: none;
    }
}
</style>